exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "li.operation{padding-bottom:10px;margin-bottom:10px;border-bottom:1px solid #ccc}.operation:last-child{border-bottom:none}div.bottom-op{padding-top:7px;display:flex;justify-content:space-between}div.bottom-op a{height:40px;width:40px;color:#fff;line-height:40px;text-align:center;background-color:#c31616;border-radius:5px;font-size:2.3rem;display:block}div.bottom-op .bottle,div.bottom-op .refrigerant{position:relative;height:40px;width:auto;padding:0 10px;color:#fff;font-size:1.8rem;font-weight:700;border-radius:5px;line-height:2;border:1px solid transparent;background-color:#999}div.bottom-op .delete{width:40px}div.bottom-op .refrigerant{background-color:#393c51}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c3403ab","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fiches/bsdd/subcomponents/OperationBouteille.vue
// module id = 632
// module chunks = 0